/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-10-27 15:57:36
 * @modify date 2021-10-27 15:57:36
 * @desc [产品列表参数]
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { BaseModel } from '../bases';
export class SearchParams extends BaseModel<{ Category: any; Label: any }> {
  /**
   * @desc 转换 Category
   */
  formatCategory(Category) {
    const mapEnum = (item) => {
      const children = lodash.get(item, 'children', []);
      return {
        _id: item.id,
        id: item.categoryCode,
        label: item.alias,
        value: item.alias,
        text: item.alias,
        code: item.categoryCode,
        children: lodash.map(children, mapEnum),
      };
    };
    return lodash.map(Category, mapEnum);
  }
  /**
   * @desc 转换 Label
   */
  formatLabel(Label) {
    return lodash.map(Label, (item) => {
      const children = lodash.get(item, 'goodsParameterValueDTOS', []);
      return {
        label: item.attributeName,
        value: item.attributeName,
        children: lodash.map(children, (cld) => ({
          label: cld.parameterName,
          value: cld.parameterName,
        })),
      };
    });
  }
  setSearchParams(Category, Label = []) {
    this.set({
      Category: this.formatCategory(Category),
      Label: this.formatLabel(Label),
    });
  }
  getSeries(category) {
    category = lodash.find(this.Category, ['value', category]);
    const series = lodash.cloneDeep(lodash.get(category, 'children', []));
    return lodash.map(series, (item) => {
      let children = lodash.get(item, 'children', []);
      if (lodash.size(children)) {
        children = lodash.concat(
          [
            {
              id: item.code,
              label: '全部',
              value: '全部',
              text: '全部',
              code: item.code,
            },
          ],
          children,
        );
      }
      return lodash.assign(item, { children });
    });
  }
  @computed
  get Category() {
    return this.value?.Category || [];
  }
  @computed
  get Label() {
    return this.value?.Label || [];
  }
}
